import { useEffect, useState } from 'react';
import { nowMinute } from '../../redux/food/selectors';

/**
 * The current minute (nowMinute()), the clock the food store's selectors take, re-rendering when it
 * turns, so a row checked off a day ago stops being shown struck without anything else changing.
 */
export default function useNowMinute() {
	const [minute, setMinute] = useState(() => nowMinute());
	useEffect(() => {
		let timer = null;
		const next = () => {
			timer = setTimeout(() => {
				setMinute(nowMinute());
				next();
			}, 60000 - (Date.now() % 60000) + 50);
		};
		next();
		return () => clearTimeout(timer);
	}, []);
	return minute;
}
